const normalizeBaseUrl = (value?: string): string => value?.replace(/\/+$/, '') ?? ''

export const apiConfig = {
  apiBaseUrl: normalizeBaseUrl(process.env.REACT_APP_API_BASE_URL),
  ideasbankApiBaseUrl: normalizeBaseUrl(process.env.REACT_APP_IDEASBANK_API_URL),
  pg3ApiBaseUrl: normalizeBaseUrl(process.env.REACT_APP_PG3_API_URL),
}

export const apiBaseUrls = {
  api: apiConfig.apiBaseUrl,
  ideasbank: apiConfig.ideasbankApiBaseUrl,
  pg3Api: apiConfig.pg3ApiBaseUrl,
}
